import { render, staticRenderFns } from "./lawsuit_index.vue?vue&type=template&id=3dbf6448&scoped=true"
import script from "./lawsuit_index.vue?vue&type=script&lang=js"
export * from "./lawsuit_index.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_index.vue?vue&type=style&index=0&id=3dbf6448&prod&scoped=true&lang=less"
import style1 from "./lawsuit_index.vue?vue&type=style&index=1&id=3dbf6448&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf6448",
  null
  
)

export default component.exports